import * as React from 'react';

function SvgGuests(props) {
  return (
    <svg width="1.5em" height="1.5em" viewBox="0 0 26.857 27.016" {...props}>
      <g data-name="Group 2518" fill="#eea804">
        <path
          data-name="Path 2203"
          d="M1.685 16.004a2.584 2.584 0 012.74-2.528h8.793v-1.68H4.425A4.277 4.277 0 000 16.004v11.012h1.685z"
        />
        <path
          data-name="Path 2204"
          d="M10.11 10.108a5.055 5.055 0 10-5.055-5.055 5.061 5.061 0 005.055 5.055m0-8.426a3.37 3.37 0 11-3.37 3.37 3.374 3.374 0 013.37-3.37"
        />
        <path
          data-name="Path 2205"
          d="M15.061 12.692v3.37h-5.055v10.846h16.849V16.062H21.8v-3.37zm10.111 12.53H11.691v-7.475h13.481zm-5.055-9.16h-3.37v-1.685h3.37z"
        />
      </g>
    </svg>
  );
}

export default SvgGuests;
